import React, { useEffect, useState } from 'react'
import { Button, Container, Stack, Typography } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Modal, Form } from 'react-bootstrap';
import { Url } from '../url/url';
import Iconify from '../components/iconify';


const initialData = {
    coupon: "",
    discountType: "",
    discount: "",
    limit: ""
};
const CouponCode = () => {

    const [coupon, setCoupon] = useState([])
    const [show, setShow] = useState(false);
    const [showEditModel, setShowEditModel] = useState(false);

    const [formData, setFormData] = useState(initialData);
    const [err, setErr] = useState("")
    const [editFormData, setEditFormData] = useState({})
    const [loading, setLoading]= useState(false)

    // Modal Handlers
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // Handle form input changes
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    const handleEditChange = (e) => {
        setEditFormData({ ...editFormData, [e.target.name]: e.target.value });
    };
    const handleOpenEditModelFunc = (value) => {
        setErr('')
        setEditFormData(value)
        setShowEditModel(true)
    }
    const handleCloseEditModelFunc = () => {
        setErr('')
        setShowEditModel(false)
        setEditFormData({})
    }
    


    const fetchCouponCodeFunc = async () => {
        setLoading(true)
        try {
            const response = await axios.get(`${Url}/api/coupon/all`)
            setCoupon(response.data)
        } catch (error) {
            console.log(error);
        }
        finally{
            setLoading(false)
        }
    }

    const updateCouponStatus = async(couponId, status)=>{
        if(!couponId)return
        setLoading(true)
        try {
            const response = await axios.put(`${Url}/api/coupon/update-status/${couponId}` , {status}); 
            if(response.status === 200){
                fetchCouponCodeFunc()
            }
        } catch (error) {
            console.log(error);
            
        }finally{
            setLoading(false)
        }
    }




    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setErr()
        console.log("formData", formData);

        try {
            if (!formData.discountType || !formData.coupon || !formData.discount) {
                setErr("All field are required")
                return
            }
            const res = await axios.post(`${Url}/api/coupon/create`, formData);
            if (res.status === 201) {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: " Added new Coupon successfully",
                    showConfirmButton: false,
                    timer: 1500
                })
                fetchCouponCodeFunc()
            }
            setFormData(initialData);
            handleClose();
        } catch (error) {
            console.error(error);
        }
    };
    const handleSubmitEditForm = async (e) => {
        e.preventDefault();
        setErr("")
        try {
            if (!editFormData.discountType || !editFormData.coupon || !editFormData.discount) {
                setErr("All field are required")
                return
            }
            const res = await axios.put(`${Url}/api/coupon/update/${editFormData._id}`, editFormData);
            if (res.status === 200) {
                Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: " Updated coupon successfully",
                    showConfirmButton: false,
                    timer: 1500
                })
                fetchCouponCodeFunc()
            }
            setEditFormData({});
            handleCloseEditModelFunc();
        } catch (error) {
            console.error(error);
        }
    };
    // Handle delete category
    const handleDelete = (e, id) => {
        e.preventDefault();
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await axios.delete(`${Url}/api/coupon/remove/${id}`);
                    if (res.status === 200) {
                        Swal.fire({
                            position: "top-end",
                            icon: "success",
                            title: "Coupon removed successfully",
                            showConfirmButton: false,
                            timer: 1500
                        })
                        fetchCouponCodeFunc()
                    }
                } catch (error) {
                    console.error(error);
                }

            }
        });
    };




    useEffect(() => {
        fetchCouponCodeFunc()
    }, [])
    return (
        <>
            <div className="container mt-4">
                <Container>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                        <Typography variant="h4" gutterBottom>
                            Coupon Code
                        </Typography>
                        <span className='text-white'>
                            <Button variant="contained" onClick={handleShow} startIcon={<Iconify icon="eva:plus-fill" />}> Add New Coupon</Button>
                        </span>
                    </Stack>
                </Container>
                <div className="row">
                    {coupon && coupon.length > 0 ? (
                        coupon.map((value) => (
                            <div key={value._id} className="col-lg-4 col-md-4 col-sm-6 mb-3">
                                <div
                                    className="card p-3 shadow-sm text-center"
                                    style={{
                                        background: "white",
                                        borderRadius: "15px",
                                        transition: "0.3s",
                                        color: "#fff",
                                        boxShadow: "0 5px 10px rgba(0,0,0,0.1)",
                                        cursor: "pointer",
                                        border: "1px dashed #ED2224"

                                    }}
                                >
                                    <div className="card-body">
                                        <h5 className="fw-bold text-dark">
                                            <i className="fa-solid fa-ticket-alt" />  {value.coupon}
                                        </h5>
                                        <p className="fw-semibold text-dark mb-1">
                                            Discount: {value.discountType === "percentage"
                                                ? `${value.discount} %`
                                                : `₹ ${value.discount}`}
                                        </p>
                                        <p className='text-dark'>Remaining Limit : {value.limit}</p>

                                        {/* value._id, value.status  */}
                                        <button className={`badge border-0 p-2 ${value.status ? "bg-success" : "bg-danger"}`} disabled={loading} onClick={()=>updateCouponStatus(value._id, !value.status)}>
                                            {value.status ? "✅ Active" : "❌ Inactive"}
                                        </button> 
                                        <div className="d-flex justify-content-center gap-2 mt-3">
                                            <button
                                                className="btn border-dark  text-dark shadow-sm px-3 py-1 rounded-pill fw-bold"
                                                onClick={() => handleOpenEditModelFunc(value)}
                                                type='button'
                                                style={{
                                                    color: "white",
                                                    // border: "2px solid #ff758c"
                                                }}
                                            >
                                                <i className="fa-regular fa-pen-to-square text-dark" /> Edit
                                            </button>
                                            <button
                                                className="btn border-dark text-dark shadow-sm px-3 py-1 rounded-2 fw-bold"
                                                type='button'
                                                onClick={(e) => handleDelete(e, value._id)}
                                            >
                                                <i className="fa-solid fa-trash-can text-dark" />  Delete
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="col-12 text-center">
                            <p className="alert alert-warning">No Coupons Available</p>
                        </div>
                    )}
                </div>
            </div>
            <Modal size="md" show={showEditModel} onHide={handleCloseEditModelFunc} style={{ zIndex: "9999" }}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Coupon</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmitEditForm}>
                        <p className='text-danger'>{err}</p>
                        <Form.Group controlId="formCategoryName">

                            <Form.Label>Coupon Code <span className='text-danger'>*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="coupon"
                                value={editFormData.coupon}
                                onChange={handleEditChange}
                                autoFocus
                                placeholder='enter your coupon code'
                                className='mb-3'
                                required
                            />

                            <Form.Label>Discount Type <span className='text-danger'>*</span></Form.Label>
                            <Form.Select name="discountType" className='mb-3 border-dark' value={editFormData.discountType} onChange={handleEditChange}>
                                <option value="">Choose one</option>
                                <option value="flat">Flat Discount</option>
                                <option value="percentage">Percentage</option>
                            </Form.Select>
                            <Form.Label>Discount <span className='text-danger'>*</span></Form.Label>
                            <Form.Control
                                type="number"
                                name="discount"
                                value={editFormData.discount}
                                onChange={handleEditChange}
                                autoFocus
                                placeholder='enter your Discount'
                                className='mb-3'
                                required
                            />

                            <Form.Label>Limit <span className='text-danger'>*</span></Form.Label>
                            <Form.Control
                                type="number"
                                name="limit"
                                value={editFormData.limit}
                                onChange={handleEditChange}
                                autoFocus
                                placeholder='enter your limit'
                                className='mb-3'
                                required
                            />

                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-primary' type='button' onClick={handleSubmitEditForm}>
                        Update
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Add coupon Modal */}
            <Modal size="md" show={show} onHide={handleClose} style={{ zIndex: "9999" }}>
                <Modal.Header closeButton>
                    <Modal.Title>Generate New Coupon Code</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>

                        <p className='text-danger'>{err}</p>
                        <Form.Group controlId="formCategoryName">


                            <Form.Label>Coupon Code <span className='text-danger'>*</span></Form.Label>
                            <Form.Control
                                type="text"
                                name="coupon"
                                value={formData.coupon}
                                onChange={handleChange}
                                autoFocus
                                placeholder='enter your coupon code'
                                className='mb-3'
                                required
                            />
                            <Form.Label>Discount Type <span className='text-danger'>*</span></Form.Label>
                            <Form.Select name="discountType" className='mb-3 border-dark' value={formData.discountType} onChange={handleChange}>
                                <option value="">Choose one</option>
                                <option value="flat">Flat Discount</option>
                                <option value="percentage">Percentage</option>
                            </Form.Select>
                            <Form.Label>Discount <span className='text-danger'>*</span></Form.Label>
                            <Form.Control
                                type="number"
                                name="discount"
                                value={formData.discount}
                                onChange={handleChange}
                                autoFocus
                                placeholder='enter your Discount'
                                className='mb-3'
                                required
                            />
                            <Form.Label>Limit <span className='text-danger'>*</span></Form.Label>
                            <Form.Control
                                type="number"
                                name="limit"
                                value={formData.limit}
                                onChange={handleChange}
                                autoFocus
                                placeholder='enter your limit'
                                className='mb-3'
                                required
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-primary' type='button' onClick={handleSubmit}>
                        Submit
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CouponCode 